import { makeStyles } from "@material-ui/core/styles";


export const useStyles = makeStyles(theme => ({
    marker: {
        height: "2.5rem",
        width: "2.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#FFF",
        border: `6px solid ${theme.palette.secondary.main}`,
        borderRadius: "100%",
        color: "#000",
        fontWeight: "bolder",
        cursor: "pointer",
        transform: "translate(-50%, -50%)",
    },
    tooltip: {
        opacity: 0.9,
        "& .MuiTooltip-tooltip": {
            fontSize: 10,
            color: theme.palette.common.white,
            backgroundColor: theme.palette.primary.main,
        },
    },
}));
